import {isNullOrUndefined} from "../../../../services/Validator";

export default function FlashQuestionTabletLayout({children}) {
    // Used in QuestionStepScreen to frame screen content in tablet mode

    // BUILD
    if (isNullOrUndefined(children))
        return null
    return (
        <div className={"hidden sm:w-[584px] md:w-[640px] grow sm:flex sm:flex-col lg:hidden items-center justify-start space-y-[24px] pb-[16px]"}>
            {children}
        </div>
    );
}